import React, { Component } from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Login from './routes/Login/containers/Login'
import Home from './routes/Home/containers/Home'
import Allocations from './routes/Allocations/containers/Allocations'
import RouteView from './routes/Settings/components/RouteView'
import Error from './routes/Error/containers/Error'

import AuthHOC from 'containers/AuthHOC'
import LayoutHOC from 'containers/LayoutHOC'

class App extends Component {
	render() {
		return <BrowserRouter>
			<Switch>
				<Route exact path="/" component={Login}/>
				<Route path="/home" component={AuthHOC(LayoutHOC(Home))}/>
				<Route path="/allocations" component={AuthHOC(LayoutHOC(Allocations))}/>
				<Route path="/settings" component={AuthHOC(LayoutHOC(RouteView))}/>
				<Route path="/*" component={Error}/>
			</Switch>
		</BrowserRouter>
	}
}

export default App


// WEBPACK FOOTER //
// ./src/App.js